import { render } from "./orgIndex.vue?vue&type=template&id=6f32f6a3"
import script from "./orgIndex.vue?vue&type=script&lang=js"
export * from "./orgIndex.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/saas-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__